import Component from "react-pure-render/component";
import Helmet from "react-helmet";
import React, { PropTypes } from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router";

export default class Page extends Component {
  static propTypes = {
    // Why not PropTypes.object.isRequired? Because:
    // https://github.com/rackt/react-router/issues/1505
    msg: PropTypes.object
  };

  componentWillMount() {
    const { history } = this.props;
    history.pushState(null, "/orders");
  }

  render() {
    const { msg: { home: msg } } = this.props;

    return <div className="islogged-page" />;
  }
}



// WEBPACK FOOTER //
// ./src/browser/dashboard/Page.react.js